import React from 'react';
import ErrorBoundary from '../components/ErrorBoundary';
import { getDevModeStatus } from '../helper';
const renderWidgets = ({ widgetData, isServer = false, isDesktop, inventoryPosition, position = 1, eagerLoadImages, eagerLoadInventories, componentMap, cssStyle = {}, cta, rootMargin, remoteConfigs = {}, store, }) => {
    const { children, widgetType, trackingData, previewMode, } = widgetData;
    const isDevModeEnabled = getDevModeStatus(isServer);
    const ParentWidget = componentMap[widgetType];
    if (!ParentWidget) {
        return null;
    }
    const mappedChildren = children.map((child, childIndex) => {
        const Widget = componentMap[child.widgetType];
        // * the check is redundant as we assume parent in ComponentMap,
        // * guarantees mapped children in Map
        // if (!Widget) { return null; }
        const { children: grandChildren } = child;
        if (grandChildren && grandChildren.length > 0) {
            return renderWidgets({
                widgetData: child,
                position: (childIndex + 1),
                isServer,
                isDesktop,
                inventoryPosition,
                eagerLoadImages,
                eagerLoadInventories,
                componentMap,
                cssStyle,
                cta,
                rootMargin,
                remoteConfigs,
                store,
            });
        }
        const { id, positionInParent, params, transactionId, devModeData, pwType, cwType, } = child;
        return (React.createElement(Widget, { id: id, key: id, positionInParent: positionInParent, params: params, transactionId: transactionId, isServer: isServer, isDesktop: isDesktop, trackingData: trackingData, inventoryPosition: inventoryPosition, parentPosition: (position), eagerLoadImages: eagerLoadImages, eagerLoadInventories: eagerLoadInventories, cssStyle: cssStyle, cta: cta, isDevModeEnabled: isDevModeEnabled, devModeData: devModeData, rootMargin: rootMargin, pwType: pwType, cwType: cwType, remoteConfigs: remoteConfigs, store: store }));
    });
    const { id, positionInParent, params, transactionId, devModeData, pwType, cwType, } = widgetData;
    return (React.createElement(ErrorBoundary, { isServer: isServer },
        React.createElement(ParentWidget, { key: id, id: id, positionInParent: positionInParent, params: params, transactionId: transactionId, isServer: isServer, isDesktop: isDesktop, trackingData: trackingData, inventoryPosition: inventoryPosition, parentPosition: position, eagerLoadImages: eagerLoadImages, eagerLoadInventories: eagerLoadInventories, cssStyle: cssStyle, isDevModeEnabled: isDevModeEnabled, devModeData: devModeData, previewMode: previewMode, rootMargin: rootMargin, pwType: pwType, cwType: cwType, remoteConfigs: remoteConfigs, store: store }, mappedChildren)));
};
export default renderWidgets;
